import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Textarea } from "@/components/ui/textarea";
import { api, formatError } from "@/lib/api";

export const FunzioniDialog = ({ negozio, catalogo, onClose, onSaved }) => {
  const [sel, setSel] = useState([]);
  const [note, setNote] = useState("");
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    if (negozio) { setSel(negozio.funzioni || []); setNote(negozio.note_personalizzazioni || ""); }
  }, [negozio]);
  const toggle = (k, on) => setSel((s) => (on ? [...s, k] : s.filter((x) => x !== k)));
  const salva = async () => {
    setSaving(true);
    try {
      await api.patch(`/superadmin/negozi/${negozio.id}/funzioni`, { funzioni: sel, note });
      toast.success("Funzioni su misura aggiornate");
      onSaved(); onClose();
    } catch (e) { toast.error(formatError(e)); } finally { setSaving(false); }
  };
  return (
    <Dialog open={Boolean(negozio)} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-lg" data-testid="funzioni-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl">Funzioni su misura · {negozio?.nome}</DialogTitle>
          <DialogDescription>Le funzioni accese qui sono visibili solo a questo negozio.</DialogDescription>
        </DialogHeader>
        <div className="space-y-2" data-testid="funzioni-lista">
          {catalogo.map((f) => (
            <label key={f.chiave} className="flex items-center justify-between gap-4 rounded-md border border-slate-200 p-3">
              <span className="text-sm text-slate-800">{f.descrizione}</span>
              <Switch checked={sel.includes(f.chiave)} onCheckedChange={(on) => toggle(f.chiave, on)} data-testid={`funzione-switch-${f.chiave}`} />
            </label>
          ))}
          {!catalogo.length && <p className="rounded-md border border-dashed border-slate-200 p-4 text-sm text-slate-500" data-testid="funzioni-vuote">Non ci sono ancora funzioni su misura. Quando ne aggiungiamo una per un cliente, comparirà qui e potrai accenderla solo per lui.</p>}
        </div>
        <div>
          <p className="mb-1.5 text-xs font-bold uppercase tracking-wider text-slate-500">Richieste del cliente / note</p>
          <Textarea rows={3} value={note} onChange={(e) => setNote(e.target.value)} placeholder="Es. vuole un campo per la taglia del casco sulla scheda" data-testid="funzioni-note-input" />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="funzioni-annulla">Annulla</Button>
          <Button onClick={salva} disabled={saving} className="bg-orange-600 hover:bg-orange-700" data-testid="funzioni-salva">{saving ? "Salvataggio..." : "Salva"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
